import { Component } from '@angular/core';
import { LayoutModule } from '../../../layout/layout.module';
import { UsersModule } from '../../../../users/users.module';

@Component({
  selector: 'app-profile-dashboard-page',
  standalone: true,
  imports: [
    LayoutModule,
    UsersModule,
  ],
  templateUrl: './profile-dashboard-page.component.html',
})
export class ProfileDashboardPageComponent { }
